"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MAX_MEETING_TRANSCRIPT_LENGTH () {
        return MAX_MEETING_TRANSCRIPT_LENGTH;
    },
    get MeetingTranscriptsSchema () {
        return MeetingTranscriptsSchema;
    },
    get countTranscriptCharacters () {
        return countTranscriptCharacters;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const _videoconference = require("../video-conference");
const MAX_MEETING_TRANSCRIPT_LENGTH = 250_000;
const countTranscriptCharacters = (content)=>content.replace(/\n/g, "").length;
const MeetingTranscriptsSchema = _base.BaseDocument.extend({
    /** Foreign key - meeting document */ meeting_id: _zod.z.instanceof(_bson.ObjectId),
    content: _zod.z.string().refine((s)=>countTranscriptCharacters(s) <= MAX_MEETING_TRANSCRIPT_LENGTH, {
        message: `String must contain at most ${MAX_MEETING_TRANSCRIPT_LENGTH} character(s)`
    }),
    created: _useractionrecord.UserActionRecord,
    updated: _useractionrecord.UserActionRecord,
    /** Provider the transcript was auto-retrieved from; absent for manually pasted transcripts. */ source: _zod.z.enum(_videoconference.VIDEO_CONFERENCING_PROVIDERS).optional(),
    /** When we ingested it from the provider. Stable across later user edits (compare with `updated`). */ retrieved_at: _zod.z.instanceof(Date).optional()
});
